import { useMutation, gql } from '@apollo/client';
import {
  DeletarHorarioMutation,
  DeletarHorarioMutationVariables,
} from './__generated__/DeletarHorarioMutation';

const DELETAR_HORARIO_MUTATION = gql`
  mutation DeletarHorarioMutation($id_horario: Int!) {
    deletarHorario(id_horario: $id_horario) {
      id_horario
    }
  }
`;

const useDeletarHorarioMutation = () => {
  return useMutation<DeletarHorarioMutation, DeletarHorarioMutationVariables>(
    DELETAR_HORARIO_MUTATION
  );
};

export { useDeletarHorarioMutation };
